import {
  Award,
  PartyPopper,
  Trophy,
  Users,
  Calendar,
  Star,
  Gift,
  Music,
  Tent,
  Target,
  BookOpen,
  GraduationCap,
  Heart,
  Briefcase,
  Sparkles,
  Flame,
  Flag,
  MapPin,
  Coffee,
  Bike,
} from 'lucide-react';

// Map iconType string -> Lucide icon component (used by Activities/Events and News)
export const iconMap = {
  allgemein: BookOpen,
  award: Award,
  bookopen: BookOpen,
  briefcase: Briefcase,
  bike: Bike,
  calendar: Calendar,
  coffee: Coffee,
  flag: Flag,
  flame: Flame,
  gift: Gift,
  graduationcap: GraduationCap,
  heart: Heart,
  mappin: MapPin,
  music: Music,
  partypopper: PartyPopper,
  sparkles: Sparkles,
  star: Star,
  target: Target,
  tent: Tent,
  trophy: Trophy,
  users: Users,
};

// Friendly labels (used in the admin icon picker)
export const iconOptions = [
  { value: 'calendar', label: 'Kalender (Standard)' },
  { value: 'trophy', label: 'Pokal / Turnier' },
  { value: 'graduationcap', label: 'Lehrgang' },
  { value: 'award', label: 'Auszeichnung / Prüfung' },
  { value: 'star', label: 'Highlight' },
  { value: 'partypopper', label: 'Feier' },
  { value: 'gift', label: 'Geschenk / Advent' },
  { value: 'music', label: 'Musik / Konzert' },
  { value: 'tent', label: 'Ausritt / Ferienlager' },
  { value: 'users', label: 'Mitglieder / Treffen' },
  { value: 'heart', label: 'Soziales' },
  { value: 'target', label: 'Wettkampf' },
  { value: 'briefcase', label: 'Arbeitseinsatz' },
  { value: 'coffee', label: 'Stammtisch' },
  { value: 'bike', label: 'Sport' },
  { value: 'flag', label: 'Saisonbeginn' },
  { value: 'flame', label: 'Lagerfeuer' },
  { value: 'mappin', label: 'Auswärtstermin' },
  { value: 'sparkles', label: 'Sonderveranstaltung' },
  { value: 'bookopen', label: 'Allgemein / Info' },
];

// Resolve icon for a news article: pick by iconType, fall back to category, then Calendar
export const getNewsIcon = (article) => {
  const key = (article?.iconType || article?.category || 'allgemein').toString().toLowerCase();
  return iconMap[key] || iconMap[(article?.category || '').toLowerCase()] || Calendar;
};

// Resolve color class by news category
export const getNewsIconColor = (category) => {
  switch ((category || '').toLowerCase()) {
    case 'erfolg':
      return 'text-yellow-500';
    case 'event':
      return 'text-pink-500';
    case 'allgemein':
    default:
      return 'text-primary';
  }
};

// Resolve icon for an event/activity
export const getActivityIcon = (activity) => {
  const key = (activity?.iconType || 'calendar').toString().toLowerCase();
  return iconMap[key] || Calendar;
};
